import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { fromGlobalId } from 'graphql-relay';
import Button from '../Button';
import Grid from '../Grid';
import Avatar from '../Avatar';
import CommunityAvailabilitySidebar from '../../containers/CommunityAvailabilitySidebar';
import SmartFormattedRelativeTime from '../SmartFormattedRelativeTime';

import * as constants from './constants';
import messages from './messages';
import './styles.css';

class NotableEvent extends React.PureComponent {
  static propTypes = {
    event: PropTypes.object.isRequired,
    displaySidebarComponent: PropTypes.func.isRequired,
    closeSidebar: PropTypes.func.isRequired,
  };

  getEventLabel = () => {
    const { event: { highSchool, eventType } } = this.props;

    const hsId = fromGlobalId(highSchool.id).id;
    const hsName = <Link to={`/rep-visits/search/${hsId}`}>{highSchool.name}</Link>;
    const publishedBold = <strong><FormattedMessage {...messages.published} /></strong>;

    switch (eventType) {
      case constants.PUBLISHED_AVAILABILITY:
        return <FormattedMessage {...messages.publishedAvailability} values={{ hsName, publishedBold }} />;
      case constants.PUBLISHED_FAIR:
        return <FormattedMessage {...messages.publishedFair} values={{ hsName, publishedBold }} />;
      default:
        return null;
    }
  }

  displayAvailablity = () => {
    const { event, closeSidebar } = this.props;
    const props = {
      schoolId: fromGlobalId(event.highSchool.id).id,
      closeFunction: closeSidebar,
    };

    this.props.displaySidebarComponent(<CommunityAvailabilitySidebar {...props} />, true);
  }

  render() {
    const { event: { timestamp } } = this.props;
    const label = this.getEventLabel();

    return (
      <li styleName="notification-grid" data-cy="repvisits-schools-availability-list" className="ui grid">
        <Grid.Row styleName="notification-row">
          <Grid.Column width={2}>
            <Avatar
              big
              icon="university"
            />
          </Grid.Column>
          <Grid.Column width={10}>
            <div styleName="notification-age"><SmartFormattedRelativeTime value={new Date(timestamp)} /></div>
            <div>{label}</div>
            <div>
              <Button basic size="small" onClick={this.displayAvailablity}>
                <FormattedMessage {...messages.seeAvailability} />
              </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </li>
    );
  }
}

export default NotableEvent;
